<template>
  <h1>匯入庫存</h1>
</template>

<script>
export default {}
</script>

<style></style>
